// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { ScriptInUse } from '../setScriptInUse';

export class ScriptClickEventArgs extends ScriptInUse {
    quickSend: boolean;
}
